export enum SelectTypeEnum {
  Checked = 'checked',
  DropDown = 'dropDown',
}
